<template>
    <div style="height:100%">
        <el-table
        :data="pinnacleInfo"
        class="pinnacleTable"
        style="width: 100%;height:100%;">
        <el-table-column
          prop="name"
          label="名称"
         >
        </el-table-column>

        <template v-if="range=='day'">
            <el-table-column
            prop="day_rush"
            label="日充电量"
          >
          </el-table-column>
          <el-table-column
            prop="day_put"
            label="日放电量"
          >
          </el-table-column>
          <el-table-column
            v-for="(item, index) in 24"
            :key="index"
            :prop="(index<10?'0'+index:index)+':00'"
            :label="(index<10?'0'+index:index)+':00'"
          >
            <el-table-column
              :prop="index+'_rush'"
              label="充电量"
              >
            </el-table-column>
            <el-table-column 
              :prop="index+'_put'" 
              label="放电量" 
              >
              
            </el-table-column>
          </el-table-column>
        </template>

        <template  v-else-if="range=='month'">
           <el-table-column
            prop="total"
            label="月充电量"
          >
          </el-table-column>
          <el-table-column
            prop="total"
            label="月放电量"
          >
          </el-table-column>
         
          <el-table-column
            v-for="item in 31"
            :key="item"
            :prop="item"
            :label="item+'日'"
          >
            <el-table-column
              prop="sum_valley"
              label="充电量"
              >
            </el-table-column>
            <el-table-column 
              prop="percentage_valley" 
              label="放电量" 
              >
              
            </el-table-column>
          </el-table-column>
        </template>
        
        <template v-else-if="range=='year'">
           <el-table-column
            prop="total"
            label="年充电量"
          >
          </el-table-column>
          <el-table-column
            prop="total"
            label="年放电量"
          >
          </el-table-column>
            <el-table-column
            v-for="item in 12"
            :key="item"
            :prop="item"
            :label="item+'月'"
          >
          <el-table-column
              prop="sum_valley"
              label="充电量"
              >
            </el-table-column>
            <el-table-column 
              prop="percentage_valley" 
              label="放电量" 
              >
            </el-table-column>
          </el-table-column>
        </template>
       
      </el-table>
    </div>
</template>


<script>
import {InverterLoop} from "../../../api/power";
import exportExcel from "../../../util/excel";
import {
  perDay,
  perMonth, 
  perYear,
  nextDay,
  nextMonth,
  nextYear,
  dateFormat,
  dayStart,
  dayEnd,
  monthStart,
  monthEnd,
  yearStart,
  yearEnd,
} from "../../../util/DateUtil";
export default {
props:{
  loops: Array,
  nodes: Array,
  range: String,
  date: Date,
},
data() {
  return {
      pinnacleInfo:[],
      titles:[]
  }
},
  async mounted() {
      let _this = this
      _this.initPowerTimeData();
  },
  computed: {
      diagramStatus(){
          return this.$store.state.project.diagramStatus
      },
      propsData() {
          return [
              this.range,
              this.date,
              this.loops,
              this.nodes
          ]
      }
  },
  watch: {
      diagramStatus(n){
          if(this.$route.query.ty === 'Energy' ){
              if(n.type === 'excel' && this.pinnacleInfo.length > 0){

                  let data = [
                      ['名称', '总发电量']
                  ]

                  this.titles.forEach(t => {
                      data[0].push(t)
                  })

                  this.pinnacleInfo.forEach(d => {
                      data.push([d.name, d.total, ...this.titles.map(t => d[t])])
                  })
                  exportExcel(data, '发电量时段报表', [])

              }else {
                  this.$message.warning("无图表数据！")
              }
          }
      },
      propsData(n) {
          this.initPowerTimeData()
      }
  },
  methods: {
      initPowerTimeData() {
          let data = []
          this.loops.forEach(item=>{
                let day_rush = 0
                let day_put = 0
                let info = {}
                if(item.label=="电池堆"){
                    info ={
                        name:item.label,
                        day_rush:day_rush,
                        day_put:day_put,
                        "0_rush":38,
                        "0_put":0,
                        "1_rush":24,
                        "1_put":0,
                        "2_rush":36,
                        "2_put":0,
                        "3_rush":38,
                        "3_put":0,
                        "4_rush":24,
                        "4_put":0,
                        "5_rush":0,
                        "5_put":0,
                        "6_rush":0,
                        "6_put":0,
                        "7_rush":0,
                        "7_put":0,
                        "8_rush":0,
                        "8_put":0,
                        "9_rush":0,
                        "9_put":0,
                        "10_rush":0,
                        "10_put":0,
                        "11_rush":0,
                        "11_put":0,
                        "12_rush":0,
                        "12_put":0,
                        "13_rush":0,
                        "13_put":0,
                        "14_rush":0,
                        "14_put":0,
                        "15_rush":0,
                        "15_put":0,
                        "16_rush":0,
                        "16_put":0,
                        "17_rush":0,
                        "17_put":0,
                        "18_rush":0,
                        "18_put":0,
                        "19_rush":0,
                        "19_put":0,
                        "20_rush":0,
                        "20_put":35,
                        "21_rush":0,
                        "21_put":61,
                        "22_rush":0,
                        "22_put":38,
                        "23_rush":0,
                        "23_put":26
                    }
                }else{
                    info ={
                        name:item.label,
                        day_rush:day_rush,
                        day_put:day_put,
                        "0_rush":7,
                        "0_put":0,
                        "1_rush":11,
                        "1_put":0,
                        "2_rush":5,
                        "2_put":0,
                        "3_rush":14,
                        "3_put":0,
                        "4_rush":9,
                        "4_put":0,
                        "5_rush":0,
                        "5_put":0,
                        "6_rush":0,
                        "6_put":0,
                        "7_rush":0,
                        "7_put":0,
                        "8_rush":0,
                        "8_put":0,
                        "9_rush":0,
                        "9_put":0,
                        "10_rush":0,
                        "10_put":0,
                        "11_rush":0,
                        "11_put":0,
                        "12_rush":0,
                        "12_put":0,
                        "13_rush":0,
                        "13_put":0,
                        "14_rush":0,
                        "14_put":0,
                        "15_rush":0,
                        "15_put":0,
                        "16_rush":0,
                        "16_put":0,
                        "17_rush":0,
                        "17_put":0,
                        "18_rush":0,
                        "18_put":0,
                        "19_rush":0,
                        "19_put":0,
                        "20_rush":0,
                        "20_put":6,
                        "21_rush":0,
                        "21_put":7,
                        "22_rush":0,
                        "22_put":4,
                        "23_rush":0,
                        "23_put":9
                    }
                }
                for (i in info) {
                    let hour = new Date().getHours()
                    if(i.split('_')[0]>hour){
                        info[i] = ""
                    }
                    if(i.indexOf("rush")>-1){
                        day_rush+=info[i]
                    }
                    if(i.indexOf("put")>-1){
                        day_put+=info[i]
                    }
                }
                info.day_rush = day_rush
                info.day_put = day_put
                data.push(info)
            })
				this.pinnacleInfo = data
      },
  }
}
</script>

<style  scoped lang="less">
.pinnacleTable /deep/.el-table__body-wrapper{
height: calc(100% - 48px);
}
.pinnacleTable /deep/.el-table__body-wrapper{
height: calc(100% - 96px);
}
</style>